import Header from "../components/layouts/common/Header";
import Footer from "../components/layouts/common/Footer";
import { Outlet, useLocation } from "react-router-dom";
import FooterCart from "../components/layouts/common/FooterCart";
import { useEffect } from "react";
import { getShopState } from "../store";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getSearchParams } from "../helpers/handleSearchParams";
export default function RootLayout() {
    const { shopInfo } = useAppSelector(getShopState);
    const dispatch = useAppDispatch();
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (window.location.search) {
            const url = new URL(window.location.href);
            const searchParamsQuery = new URLSearchParams(url.search);
            getSearchParams(searchParamsQuery);
        }
        const title = !!shopInfo.store_title ? shopInfo.store_title : shopInfo.shop_name;
        switch (window.location.pathname) {
            case "/checkout":
                const pathName = window.location.pathname.replace('/', '');
                document.title = pathName.charAt(0).toUpperCase() + pathName.slice(1) + ' - ' + title;
                break;
            case "/checkout/thank-you":
                const pathNameArr = window.location.pathname.split('/');
                const titleThanks = pathNameArr[2].replace('-', ' ');
                document.title = titleThanks.charAt(0).toUpperCase() + titleThanks.slice(1) + ' - ' + title;
                break;
        }
    }, [location, dispatch, shopInfo.store_title, shopInfo.shop_name])
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
            {location.pathname !== '/checkout' && <FooterCart />}
        </>
    )
}